import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HorizontalHomecard } from '@spotahome/ui-library';
import { withLocales } from '@spotahome/soyuz/client';
import { localesShape } from '@spotahome/soyuz/shapes';

import getGqlClient from '../../graphql/client';
import getHomecardsQuery from '../../graphql/queries/homecards';
import { getUrlWithMapParameters } from '../../utils/homecards';

import HomecardMapPlaceholder from './HomecardMapPlaceholder';
import './HomecardMap.scss';

const fetchHomecard = async (id, locale) => {
  const { data } = await getHomecardsQuery(getGqlClient())([id], locale);
  return (data && data.homecards && data.homecards[0]) || undefined;
};

const HomecardMap = ({
  id,
  locales: { current: locale },
  filters: { 'move-in': moveIn, 'move-out': moveOut },
  showPrice,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const [homecard, setHomecard] = useState();

  const currentYear = new Date().getFullYear();

  const firstAvailableDate = homecard && new Date(homecard.firstAvailableDate);
  const firstAvailableYear = firstAvailableDate?.getFullYear();

  useEffect(() => {
    setLoading(true);
    fetchHomecard(id, locale)
      .then(result => {
        setHomecard(result);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id, locale]);

  return (
    <div className="homecard-map">
      {loading || !homecard ? (
        <HomecardMapPlaceholder />
      ) : (
        <HorizontalHomecard
          {...rest}
          availableFrom={homecard.firstAvailableDate}
          type={homecard.type}
          image={homecard.mainPhotoUrl}
          link={getUrlWithMapParameters(homecard.url, moveIn, moveOut)}
          price={{
            type: homecard.monthlyPrice.type,
            amount: homecard.monthlyPrice.minimumPrice,
            currencyCode: homecard.currencyIsoCode
          }}
          title={homecard.title}
          showPrice={showPrice}
          newTab={false}
          dataTest="horizontal-homecard"
          showAvailableFromYear={firstAvailableYear !== currentYear}
        />
      )}
    </div>
  );
};

HomecardMap.propTypes = {
  id: PropTypes.number.isRequired,
  locales: PropTypes.shape(localesShape).isRequired,
  filters: PropTypes.shape({
    'move-in': PropTypes.string,
    'move-out': PropTypes.string
  }),
  showPrice: PropTypes.bool
};

HomecardMap.defaultProps = {
  filters: {
    'move-in': '',
    'move-out': ''
  },
  showPrice: false
};

export default withLocales()(HomecardMap);
